import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import parseHtml from "html-react-parser";
import React from "react";

import { useDidMount } from "../../../hooks/useDidMount";
import { YesOrNo } from "../../../interfaces/enum";
import { ModelState } from "../../../interfaces/modelState";
import { DlpState } from "../../../providers/dlpFlow/DlpFlow.interfaces";
import { Card } from "../../card/Card";
import { Insureds } from "../calculation/Insureds";
import { CrosswiseInsured } from "./CrosswiseInsured";
import { MortgageSelection } from "./MortgageSelection";

interface Props {
  fields: Record<string, Field<string>>;
  data: DlpState;
  index?: number;
  onUpdateHasMortgage: (hasMortgage: boolean) => void;
  onUpdateMortgageSupplierKey: (mortgageSupplierKey: string, mortgageSupplierLabel: string) => void;
  onUpdateInsuranceTaker: (insuredPersonIds: string[]) => void;
  onUpdateCrosswiseInsured: (crosswiseInsured: YesOrNo) => void;
  setModelState: (updatedModelState: ModelState) => void;
  modelState: ModelState | null;
}

export const AdditionalOptions = ({
  fields,
  data,
  index = 0,
  onUpdateHasMortgage,
  onUpdateMortgageSupplierKey,
  onUpdateInsuranceTaker,
  onUpdateCrosswiseInsured,
  setModelState,
  modelState,
}: Props) => {
  useDidMount(() => {
    if (data.insuredPersons.length === 1 && data.insuredPersons[0].personId) {
      onUpdateInsuranceTaker([data.insuredPersons[0].personId]);
    }
  });

  return (
    <div>
      {data.insuredPersons.length > 1 && (
        <Insureds
          fields={fields}
          name="InsuranceTaker"
          fieldName="step2Insureds"
          validationPropertyName={`model.InsuranceTaker`}
          insureds={data.insuranceTaker}
          insuredPersons={data.insuredPersons}
          modelState={modelState}
          setModelState={setModelState}
          index={index + 1}
          onUpdateInsuredPersonsIds={onUpdateInsuranceTaker}
        />
      )}
      {data.insuredPersons.length === 2 && (
        <CrosswiseInsured
          name="CrosswiseInsured"
          fields={fields}
          selectedValue={data.crosswiseInsured}
          validationPropertyName={`model.CrosswiseInsured`}
          onUpdateCrosswiseInsured={onUpdateCrosswiseInsured}
          modelState={modelState}
          setModelState={setModelState}
        />
      )}
      {((data.insuredPersons.length === 2 && data.insuranceTaker.length !== 0) || data.insuredPersons.length === 1) && (
        <MortgageSelection
          fields={fields}
          data={data}
          onUpdateHasMortgage={onUpdateHasMortgage}
          onUpdateMortgageSupplierKey={onUpdateMortgageSupplierKey}
          modelState={modelState}
        />
      )}
      <Card>
        <h2>
          <Text field={fields.HeadingCustomWork} />
        </h2>

        {fields.ContentCustomWork && parseHtml(fields.ContentCustomWork.value)}
      </Card>
    </div>
  );
};
